import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ratingListModel } from "../../models";
import { appConstants } from "../../utils/constants";
import DashboardContext from "../dashboardContext";
import { sourceIdentifier } from "../../models/sourceModel";
import { languageIdentifier } from "../../models/languageModel";
import i18n from "../../components/i18n";

export const DashboardProvider = ({ children }) => {
  // Handles query params so we can set the selected rating from the url i.e email feedback requests
  const [searchParams] = useSearchParams();
  const source_rating = searchParams.get("rating") || null;
  let source_channel = searchParams.get("source") || null;
  let source_territory =
    searchParams.get("territory") || appConstants.territory;
  let source_store_code = searchParams.get("store") || null;

  let isSourceWeb = false;

  if (source_channel === null) {
    source_channel = sourceIdentifier(
      localStorage.getItem(appConstants.surveyType).toLowerCase()
    );
  } else {
    source_channel = sourceIdentifier(source_channel.toLowerCase());
    if (source_channel === 6 || source_channel === 7) {
      isSourceWeb = true;
    }
  }

  let source_language = searchParams.get("language") || null;

  if (source_language === null) {
    source_language = languageIdentifier(
      localStorage.getItem(appConstants.language).toLowerCase()
    );
  } else {
    source_language = languageIdentifier(source_language.toLowerCase());
    const language = source_language === 1 ? appConstants.en : appConstants.ar;
    i18n.changeLanguage(language);
    localStorage.setItem(appConstants.language, language);
  }

  const rating_model = ratingListModel();

  const [dashboardStates, setDashboardStates] = useState({
    rating: null,
    parentQuestionId: null,
    parentQuestion: null,
    childQuestionId: null,
    ratingdata: rating_model,
    parentQuestiondata: null,
    childQuestiondata: null,
    showAdditionalFeedback: false,
    isSubmitted: false,
    isSubmittedMessage: appConstants.helpingUs,
    pageDirection: appConstants.ltr,
    conceptCode: null,
    qrValue: null,
    surveyType: null,
    parentQuestionloading: false,
    childQuestionloading: false,
    isSubmitClicked: false,
    isSubmitloading: false,
    mobileNumber: null,
    feedbackRemark: null,
    concent: false,
    sourceChannel: source_channel,
    sourceLanguage: source_language,
    isSourceWeb: isSourceWeb,
    sourceRating: source_rating,
    sourceTerritory: source_territory,
    storeCode: source_store_code,
  });

  const dashboardMemo = useMemo(
    () => ({ dashboardStates, setDashboardStates }),
    [dashboardStates]
  );

  return (
    <DashboardContext.Provider value={dashboardMemo}>
      {children}
    </DashboardContext.Provider>
  );
};
